export const COUNTRY_DIAL_CODES = [
    { code: "AR", name: "Argentina", dialCode: "+54" },
    { code: "AU", name: "Australia", dialCode: "+61" },
    { code: "AT", name: "Austria", dialCode: "+43" },
    { code: "BD", name: "Bangladesh", dialCode: "+880" },
    { code: "BE", name: "Belgium", dialCode: "+32" },
    { code: "BR", name: "Brazil", dialCode: "+55" },
    { code: "CA", name: "Canada", dialCode: "+1" },
    { code: "CL", name: "Chile", dialCode: "+56" },
    { code: "CO", name: "Colombia", dialCode: "+57" },
    { code: "CZ", name: "Czech Republic", dialCode: "+420" },
    { code: "DK", name: "Denmark", dialCode: "+45" },
    { code: "EC", name: "Ecuador", dialCode: "+593" },
    { code: "EG", name: "Egypt", dialCode: "+20" },
    { code: "FI", name: "Finland", dialCode: "+358" },
    { code: "FR", name: "France", dialCode: "+33" },
    { code: "DE", name: "Germany", dialCode: "+49" },
    { code: "GH", name: "Ghana", dialCode: "+233" },
    { code: "GR", name: "Greece", dialCode: "+30" },
    { code: "HU", name: "Hungary", dialCode: "+36" },
    { code: "IN", name: "India", dialCode: "+91" },
    { code: "ID", name: "Indonesia", dialCode: "+62" },
    { code: "IE", name: "Ireland", dialCode: "+353" },
    { code: "IL", name: "Israel", dialCode: "+972" },
    { code: "IT", name: "Italy", dialCode: "+39" },
    { code: "JP", name: "Japan", dialCode: "+81" },
    { code: "KE", name: "Kenya", dialCode: "+254" },
    { code: "MY", name: "Malaysia", dialCode: "+60" },
    { code: "MX", name: "Mexico", dialCode: "+52" },
    { code: "NL", name: "Netherlands", dialCode: "+31" },
    { code: "NG", name: "Nigeria", dialCode: "+234" },
    { code: "NO", name: "Norway", dialCode: "+47" },
    { code: "PK", name: "Pakistan", dialCode: "+92" },
    { code: "PE", name: "Peru", dialCode: "+51" },
    { code: "PH", name: "Philippines", dialCode: "+63" },
    { code: "PL", name: "Poland", dialCode: "+48" },
    { code: "PT", name: "Portugal", dialCode: "+351" },
    { code: "RO", name: "Romania", dialCode: "+40" },
    { code: "RU", name: "Russia", dialCode: "+7" },
    { code: "SA", name: "Saudi Arabia", dialCode: "+966" },
    { code: "SG", name: "Singapore", dialCode: "+65" },
    { code: "ZA", name: "South Africa", dialCode: "+27" },
    { code: "KR", name: "South Korea", dialCode: "+82" },
    { code: "ES", name: "Spain", dialCode: "+34" },
    { code: "SE", name: "Sweden", dialCode: "+46" },
    { code: "CH", name: "Switzerland", dialCode: "+41" },
    { code: "TH", name: "Thailand", dialCode: "+66" },
    { code: "TR", name: "Turkey", dialCode: "+90" },
    { code: "AE", name: "United Arab Emirates", dialCode: "+971" },
    { code: "GB", name: "United Kingdom", dialCode: "+44" },
    { code: "US", name: "United States", dialCode: "+1" },
    { code: "BH", name: "Bahrain", dialCode: "+973" },
    { code: "BG", name: "Bulgaria", dialCode: "+359" },
    { code: "CN", name: "China", dialCode: "+86" },
    { code: "HR", name: "Croatia", dialCode: "+385" },
    { code: "EE", name: "Estonia", dialCode: "+372" },
    { code: "HK", name: "Hong Kong", dialCode: "+852" },
    { code: "IS", name: "Iceland", dialCode: "+354" },
    { code: "JO", name: "Jordan", dialCode: "+962" },
    { code: "KW", name: "Kuwait", dialCode: "+965" },
    { code: "LV", name: "Latvia", dialCode: "+371" },
    { code: "LB", name: "Lebanon", dialCode: "+961" },
    { code: "LT", name: "Lithuania", dialCode: "+370" },
    { code: "LU", name: "Luxembourg", dialCode: "+352" },
    { code: "MT", name: "Malta", dialCode: "+356" },
    { code: "MA", name: "Morocco", dialCode: "+212" },
    { code: "NZ", name: "New Zealand", dialCode: "+64" },
    { code: "OM", name: "Oman", dialCode: "+968" },
    { code: "QA", name: "Qatar", dialCode: "+974" },
    { code: "RS", name: "Serbia", dialCode: "+381" },
    { code: "SK", name: "Slovakia", dialCode: "+421" },
    { code: "SI", name: "Slovenia", dialCode: "+386" },
    { code: "TW", name: "Taiwan", dialCode: "+886" },
    { code: "TN", name: "Tunisia", dialCode: "+216" },
    { code: "UA", name: "Ukraine", dialCode: "+380" },
    { code: "UY", name: "Uruguay", dialCode: "+598" },
    { code: "VN", name: "Vietnam", dialCode: "+84" },
];
/** Hebrew country names keyed by ISO code. Search/display only. */
export const COUNTRY_NAMES_HE = {
    AR: "ארגנטינה",
    AU: "אוסטרליה",
    AT: "אוסטריה",
    BD: "בנגלדש",
    BE: "בלגיה",
    BR: "ברזיל",
    CA: "קנדה",
    CL: "צ'ילה",
    CO: "קולומביה",
    CZ: "צ'כיה",
    DK: "דנמרק",
    EC: "אקוודור",
    EG: "מצרים",
    FI: "פינלנד",
    FR: "צרפת",
    DE: "גרמניה",
    GH: "גאנה",
    GR: "יוון",
    HU: "הונגריה",
    IN: "הודו",
    ID: "אינדונזיה",
    IE: "אירלנד",
    IL: "ישראל",
    IT: "איטליה",
    JP: "יפן",
    KE: "קניה",
    MY: "מלזיה",
    MX: "מקסיקו",
    NL: "הולנד",
    NG: "ניגריה",
    NO: "נורווגיה",
    PK: "פקיסטן",
    PE: "פרו",
    PH: "הפיליפינים",
    PL: "פולין",
    PT: "פורטוגל",
    RO: "רומניה",
    RU: "רוסיה",
    SA: "ערב הסעודית",
    SG: "סינגפור",
    ZA: "דרום אפריקה",
    KR: "דרום קוריאה",
    ES: "ספרד",
    SE: "שוודיה",
    CH: "שווייץ",
    TH: "תאילנד",
    TR: "טורקיה",
    AE: "איחוד האמירויות",
    GB: "הממלכה המאוחדת",
    US: "ארצות הברית",
    BH: "בחריין",
    BG: "בולגריה",
    CN: "סין",
    HR: "קרואטיה",
    EE: "אסטוניה",
    HK: "הונג קונג",
    IS: "איסלנד",
    JO: "ירדן",
    KW: "כווית",
    LV: "לטביה",
    LB: "לבנון",
    LT: "ליטא",
    LU: "לוקסמבורג",
    MT: "מלטה",
    MA: "מרוקו",
    NZ: "ניו זילנד",
    OM: "עומאן",
    QA: "קטר",
    RS: "סרביה",
    SK: "סלובקיה",
    SI: "סלובניה",
    TW: "טייוואן",
    TN: "תוניסיה",
    UA: "אוקראינה",
    UY: "אורוגוואי",
    VN: "וייטנאם",
};
export function findCountryByIsoCode(isoCode) {
    const normalized = isoCode.trim().toUpperCase();
    return COUNTRY_DIAL_CODES.find((c) => c.code === normalized);
}
export function findCountryByDialCode(dialCode) {
    const normalized = dialCode.startsWith("+") ? dialCode : `+${dialCode}`;
    const matches = COUNTRY_DIAL_CODES.filter((c) => normalized.startsWith(c.dialCode)).toSorted((a, b) => b.dialCode.length - a.dialCode.length);
    return matches[0];
}
export function findCountriesByDialCode(dialCode) {
    const normalized = dialCode.startsWith("+") ? dialCode : `+${dialCode}`;
    return COUNTRY_DIAL_CODES.filter((c) => c.dialCode === normalized);
}
//# sourceMappingURL=country-dial-codes.js.map